import type { FC, HTMLAttributes } from 'react';
import React from 'react';
import { Loading } from 'venn-ui-kit';
import { cn } from '@/lib/utils';

const DEFAULT_OVERLAY = <Loading />;

export interface ConditionalOverlayProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  condition: boolean;
  center?: boolean;
  contentClassName?: string;
  overlay?: JSX.Element[] | JSX.Element | string;
}

export const ConditionalOverlay: FC<React.PropsWithChildren<ConditionalOverlayProps>> = ({
  children,
  className,
  condition,
  contentClassName,
  center = false,
  overlay = DEFAULT_OVERLAY,
}: ConditionalOverlayProps) => (
  <div className={cn('relative', className)}>
    {condition && (
      <div
        className={cn(['absolute inset-0 bg-venn-white/70 z-cover [&_div]:z-cover', center ? 'flex items-center' : ''])}
      >
        {overlay}
      </div>
    )}

    <div className={cn('z-base', contentClassName)}>{children}</div>
  </div>
);
